import { Alert, FormControl, FormControlLabel, FormHelperText, Input, InputLabel, MenuItem, Paper, Select, Snackbar, Switch, Tooltip } from '@mui/material';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import { Autocomplete } from '@mui/material';
import { createFilterOptions } from '@mui/material/useAutocomplete';
import MuiAlert from '@mui/material/Alert';
import { GridSortModel } from '@mui/x-data-grid-pro';
import { Formik } from "formik";
import React, { useEffect, useRef } from "react";
import { useLocation } from 'react-router-dom';
import { Loadable, NotesDialog, NoteType, PopoverLink, ToastMessage } from '../../../common';
import AddCircleIcon from '@mui/icons-material/AddCircle';

import {
  Portlet,
  PortletBody,
  PortletHeader,
  PortletHeaderToolbar
} from "../../../partials/content/Portlet";

import { Button, Checkbox, Chip, Grid, TextField, Typography } from "@mui/material";

import makeStyles from '@mui/styles/makeStyles';

import { Card } from "react-bootstrap";
import { BackButton } from "../../../common/BackButton";
import { MODULE_TYPE_CONTRACT } from "../../../store/constants/contract";
import { asIsoDate } from "../../../util/date";
import { DocumentUpload } from "../DocumentUpload";
import { ContractsBreadCrumb } from '../ContractsBreadCrumb'; 
import ContactFieldArray from './ConfigurationFieldArrays/ContactFieldArray';
import ContractAllowableCodeSelection from "./ConfigurationFieldArrays/ContractAllowableCodeSelection";
import ContractDenialCodeSelection from "./ConfigurationFieldArrays/ContractDenialCodeSelection";
import ContractPpsSelectionCriteriaFieldArray from "./ConfigurationFieldArrays/ContractPpsSelectionCriteriaFieldArray";
import ContractEAPGSelectionCriteriaFieldArray from "./ConfigurationFieldArrays/ContractEAPGSelectionCriteriaFieldArray";
import ContractOPPSSelectionCriteriaFieldArray from "./ConfigurationFieldArrays/ContractOPPSSelectionCriteriaFieldArray";
import ContractSNFSelectionCriteriaFieldArray from "./ConfigurationFieldArrays/ContractSNFSelectionCriteriaFieldArray";
import ContractPatientResponsibilitySelection from "./ConfigurationFieldArrays/ContractPatientResponsibilitySelection";
import ContractSelectionCriteriaFieldArray from "./ConfigurationFieldArrays/ContractSelectionCriteriaFieldArray";
import ContractIRFSelectionCriteriaFieldArray from './ConfigurationFieldArrays/ContractIRFSelectionCriteriaFieldArray';
import ContractIPFSelectionCriteriaFieldArray from './ConfigurationFieldArrays/ContractIPFSelectionCriteriaFieldArray';
import ContractOverrideGroupFieldArray from './ConfigurationFieldArrays/ContractOverrideGroupFieldArray';
import ContractLTCHSelectionCriteriaFieldArray from './ConfigurationFieldArrays/ContractLTCHSelectionCriteriaFieldArray';
import ContractNonCoveredSelection from './ConfigurationFieldArrays/ContractNonCoveredSelection';
import ContractPricerStatsFieldArray from './ConfigurationFieldArrays/ContractPricerStatsFieldArray';
import EntityAuditLogsDialog from '../../TrailLogsPage/EntityAuditLogsDialog';
import { toast } from 'react-toastify';

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const useStyles = makeStyles(theme => ({
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  textField: {
    width: '85%',
  },
  formControlDropdown: {
    marginTop: theme.spacing(2),
    width: '85%',
  },
  description: {
    width: '83%',
  },
  portlet: {
    'box-shadow': 'none',
  },
  successIcon: {
    color: 'green'
  },
  errorIcon: {
    color: 'red'
  },
  formControl: {
    margin: theme.spacing(1),
    width: '100%',
  },
  formControlType: {
    marginTop: theme.spacing(2),
    marginRight: theme.spacing(1),
    width: '85%',
  },
  checkbox: {
    marginTop: theme.spacing(3),
    marginLeft: theme.spacing(0),
  },
  panel: {
    marginBottom: theme.spacing(1),
    'box-shadow': 'none !important',
    border: '1px solid #dddddd',
    borderRadius: 4,
  },
  switch: {
    //margin: theme.spacing(1),
  },
  button: {
    margin: theme.spacing(1)
  },
  formControlAuto: {
    marginTop: theme.spacing(5),
    width: '85%',
  },
  paper: {
    marginTop: theme.spacing(1),
  },
  facilityFormControlAuto: {
    marginTop: theme.spacing(2),
    width: '85%',
  },
  helpClass: {
    position: 'relative',
    top: -3,
    marginLeft: -10,
    pointerEvents:"auto"
  },
  redColor: {
    color: '#fd397a',
  },
  errorText: {
    color: '#fd397a',
    fontSize: '12px',
    marginBottom: 0
  },
  disabledSection: {
      color: 'rgba(0, 0, 0, 0.26)',
      boxShadow: 'none',
      backgroundColor: 'rgba(0, 0, 0, 0.12)',
      cursor: 'not-allowed'
  },
  helpIcon: {
    color: 'red',
    padding: 0,
    minWidth: 'auto',
  },
}));


export default function ContractsEditPage({
  intl, initialValues, contractsGetPending, contractId, contactTemplate, contractsStates, casCodes, drgs,
  contractsCreatePending, history, contractsUpdatePending, mode, clientId, alertUsers, facilities, contractCriteria, oppsList, eapgList,directoryId,hasEapgAccess,
  npiRoles, dischargeStatusCodes, tinyContracts, contractOverrideCriteria, notes, notesCount, notesListPending, notesSavePending, notesExportPending,
  notesSaveError, notesSaveErrorMessage,
  actions: { contractGet, contractCreate, contractUpdate, contractDocumentList, contractGetAlertUsers, getOPPSTiny, getEAPGTiny,
    contractGetFacilities, contractEditReset, getContractCriteria, getStates, getCascodes, getDRGTiny,getHierarchy, getNpiRoles, getDischargeStatusCodes,
    getTinyContracts, getContractOverrideCriteria, getNotes, createNote, exportNotes
} }) {
  const NOTES_PAGE_SIZE = 10;
  const DEFAULT_NOTES_SORT: GridSortModel = [{ field: 'createdAt', sort: 'desc' }];
  const toBackendNotesSort = (model: GridSortModel = DEFAULT_NOTES_SORT) => {
    const normalized = model.filter((x) => x.sort === 'asc' || x.sort === 'desc');
    const source = normalized.length > 0 ? normalized : DEFAULT_NOTES_SORT;
    return source.map((x) => ({ id: x.field, direction: x.sort as 'asc' | 'desc' }));
  };
  const [eapgEffectiveDateWarning, setEapgEffectiveDateWarning] = React.useState(false);
  const [notesOpen, setNotesOpen] = React.useState(false);
  const [notesPage, setNotesPage] = React.useState(0);
  const [notesSortModel, setNotesSortModel] = React.useState<GridSortModel>(DEFAULT_NOTES_SORT);
  const previousNotesSavePending = useRef(false);
  const formikRef = useRef();
  const [auditLogsOpen, setAuditLogsOpen] = React.useState(false);
  


  const search = useLocation().search;
  const isFromIPPS = (Boolean)(new URLSearchParams(search).get('fromipps'));
  const isFromOPPS = (Boolean)(new URLSearchParams(search).get('fromopps'));
  const isFromSNF = (Boolean)(new URLSearchParams(search).get('fromsnf'));
  const isFromEAPG = (Boolean)(new URLSearchParams(search).get('fromeapg'));
  const isFromIRF = (Boolean)(new URLSearchParams(search).get('fromirf'));
  const isFromIPF = (Boolean)(new URLSearchParams(search).get('fromipf'));
  const isFromLTCH = (Boolean)(new URLSearchParams(search).get('fromltch'));

  const classes = useStyles();
  const isEdit = mode === 'edit';

  const handleCallback = (newContractId) => {
    history.push(`/cms/contract/view/${newContractId}${directoryId ? `/${directoryId}`:''}`);
  }

  const handleEditCallback = () => {
    history.push(`/cms/contract/view/${contractId}${directoryId ? `/${directoryId}`:''}`);
  }

  useEffect(() => {
    getOPPSTiny();
  }, [getOPPSTiny]);

  useEffect(() => {
    getDRGTiny();
  }, [getDRGTiny]);

  useEffect(() => {
    getEAPGTiny();
  }, [getEAPGTiny]);

  useEffect(() => {
    getCascodes()
  }, [getCascodes]);

  useEffect(() => {
    getStates();
  }, [getStates]);

  useEffect(() => {
    getContractCriteria();
  }, [getContractCriteria]);

  useEffect(() => {
    getHierarchy();
  }, [getHierarchy]);

  useEffect(() => {
    getNpiRoles();
  }, [getNpiRoles]);

  useEffect(() => {
    getDischargeStatusCodes();
  }, []);

  useEffect(() => {
    return () => {
      contractEditReset();
    }
  }, []);

  useEffect(() => {
    contractGetFacilities();
  }, [contractGetFacilities]);

  useEffect(() => {
    getTinyContracts();
  }, [getTinyContracts]);

  useEffect(() => {
    getContractOverrideCriteria();
  }, [getContractOverrideCriteria]);

  useEffect(() => {
    contractGetAlertUsers(clientId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [contractGetAlertUsers]);

  useEffect(() => {
    if (document.readyState === 'complete' && !contractsGetPending && !contractsCreatePending && !contractsUpdatePending) {
      if(isFromIPPS) { RedirectToSection('ipps-div'); }
      else if(isFromOPPS) { RedirectToSection('opps-div'); }
      else if(isFromSNF) { RedirectToSection('snf-div'); }
      else if(isFromEAPG) { RedirectToSection('eapg-div'); }
      else if(isFromIRF) { RedirectToSection('irf-div'); }
      else if(isFromIPF) { RedirectToSection('ipf-div'); }
      else if(isFromLTCH) { RedirectToSection('ltch-div'); }
    }
  }, [isFromIPPS, isFromOPPS, isFromSNF, isFromEAPG, isFromIRF, isFromIPF, isFromLTCH, contractsGetPending, contractsCreatePending, contractsUpdatePending]);

  useEffect(() => {
    if (mode === 'edit') {
      contractGet(contractId);
    }
  }, [mode, contractGet, contractId]);

  useEffect(() => {
    if (mode === 'edit') {
      getNotes(
        NoteType.Contract,
        1,
        NOTES_PAGE_SIZE,
        contractId,
        toBackendNotesSort(DEFAULT_NOTES_SORT),
      );
    }
  }, [mode, getNotes, contractId]);

  useEffect(() => {
    if (previousNotesSavePending.current && !notesSavePending) {
      if (!notesSaveError) {
        toast.success("Note saved successfully.", {
          autoClose: 3000,
        });
      }}
    previousNotesSavePending.current = notesSavePending;
  }, [notesSavePending]);

  function RedirectToSection(secName) {
      const element = document.getElementById(secName);
      
      if(!element) return;

      const position = element.getBoundingClientRect();
      const x = position.left;
      const y = position.top;
      window.scrollTo(x, y - 70); // subtracting header height
  }

  function handleUploadCallback(callback, id) {
    // setOpen(true)
    contractDocumentList(contractId, (docData) => callback({ id: id?.id, docData }))
  }


  const filterOptions = createFilterOptions<{ name: string; email: string }>({
    stringify: option => option.name + ' ' + option.email,
  });

  const facilityFilterOption = createFilterOptions<{ name: string }>({
    stringify: option => option.name
  });

  const handleDenialCasCodeToggleChange = (e, setFieldValue) => {
    setFieldValue('isDenialCasCodeActive', e.target.checked);
    if (e.target.checked) {
      const defaultSelectedCascodes = casCodes.filter(item => item.isDenial === true);
      setFieldValue('contractDenialCascodeXref', defaultSelectedCascodes);
    }
  }

  const handleAllowableToggleChange = (e, setFieldValue) => {
    setFieldValue('isAllowableCodeActive', e.target.checked);
  }

  const handleRedirectToContractView = () => {
    history.push(`/cms/contract/view/${contractId}${directoryId ? `/${directoryId}`:''}`);
  }

  const loadNotesPage = (page: number) => {
    getNotes(
      NoteType.Contract,
      page + 1,
      NOTES_PAGE_SIZE,
      contractId,
      toBackendNotesSort(notesSortModel),
    );
  };

  const handleOpenNotes = () => {
    setNotesSortModel(DEFAULT_NOTES_SORT);
    setNotesPage(0);
    getNotes(
      NoteType.Contract,
      1,
      NOTES_PAGE_SIZE,
      contractId,
      toBackendNotesSort(DEFAULT_NOTES_SORT),
    );
    setNotesOpen(true);
  };

  const handleRefreshNotes = () => {
    loadNotesPage(notesPage);
  };

  const handleNotesPageChange = (nextPage: number) => {
    setNotesPage(nextPage);
    loadNotesPage(nextPage);
  };

  const handleNotesSortModelChange = (nextSortModel: GridSortModel) => {
    const normalizedSortModel = nextSortModel.filter((x) => x.sort === 'asc' || x.sort === 'desc');
    const safeSortModel = normalizedSortModel.length > 0 ? normalizedSortModel : DEFAULT_NOTES_SORT;
    setNotesSortModel(safeSortModel);
    setNotesPage(0);
    getNotes(
      NoteType.Contract,
      1,
      NOTES_PAGE_SIZE,
      contractId,
      toBackendNotesSort(safeSortModel),
    );
  };

  const handleSaveNotes = ({ creates = [] }) => {
    const totalCreates = creates.length;
    if (totalCreates === 0) {
      return;
    }

    let pendingCreates = totalCreates;
    const onRequestDone = () => {
      pendingCreates -= 1;
      if (pendingCreates <= 0) {
        loadNotesPage(notesPage);
      }
    };

    creates.forEach((item) => {
      createNote({ type: item.type, note: item.note, entityId: item.entityId }, onRequestDone);
    });
  };

  const downloadBlob = (file: Blob, fileName: string) => {
    const url = URL.createObjectURL(file);
    const anchor = document.createElement('a');
    anchor.href = url;
    anchor.setAttribute('download', fileName || `Notes_${NoteType.Contract}.csv`);
    document.body.appendChild(anchor);
    anchor.click();
    document.body.removeChild(anchor);
    URL.revokeObjectURL(url);
  };

  const handleExportNotes = async ({
    scope,
    ids,
    page,
    pageSize,
    entityName
  }: {
    scope: 'selected' | 'page' | 'all';
    ids?: number[];
    page?: number;
    pageSize?: number;
    entityName?: string;
  }) => {
    exportNotes(NoteType.Contract, scope, ids, page, pageSize, contractId, entityName, (response) => {
      if (response?.file) {
        downloadBlob(response.file, response.fileName || `Notes_${NoteType.Contract}.csv`);
      }
    });
  };

  const checkEapgEffectiveDateWarning = (effectiveDate, eapgRecords = []) => {
    if (!effectiveDate || !Array.isArray(eapgRecords) || eapgRecords.length === 0) {
      setEapgEffectiveDateWarning(false);
      return null;
    } 
    const effectiveDates = eapgRecords
      .map((rec) => {
        let effecDate = new Date(rec.effectiveFrom);
        return isNaN(effecDate.getTime()) ? null : effecDate.getTime();
      })
      .filter((date) => date !== null);
    if (!effectiveDate || effectiveDates.length === 0) {
      setEapgEffectiveDateWarning(false);
      return null;
    }
    const minEffectiveDateTimestamp = Math.min(...effectiveDates as number[]);
    const contractEffectiveDate = new Date(effectiveDate);
    if (minEffectiveDateTimestamp > contractEffectiveDate.getTime()) {
      setEapgEffectiveDateWarning(true);
    }
    else {
      setEapgEffectiveDateWarning(false);
    }
  };
  
  function hoverColumn(text) {
    return (
      <PopoverLink
        columnData={<i className={`${classes.helpIcon} fas fa-question-circle text-info`}></i>}
        hoverData={[
          {
            data: text
          }
        ]}
      />
    );
  }

  function validateIPPSConfigurations(values, errors, intl) {
    const drgconfigurationToContractXrefError = values.drgconfigurationToContractXref.map((crite, index) => {
      const criteriaError = {};
      let hasError = false;
      
      if (crite.percentage === '') {
        criteriaError['percentage'] = intl.formatMessage({
          id: "AUTH.VALIDATION.REQUIRED_FIELD"
        });
        hasError = true;
      } else if (parseInt(crite.percentage) < 0) {
        criteriaError['percentage'] = 'Percentage value should be greater than 0'
        hasError = true;
      }

      if (!crite.effectiveFrom) {
        criteriaError['effectiveFrom'] = intl.formatMessage({
          id: "AUTH.VALIDATION.REQUIRED_FIELD"
        });
        hasError = true;
      } else {
        if(index > 0) {
          const criteEF = new Date(crite.effectiveFrom);
          const previousDate = new Date(values.drgconfigurationToContractXref[index - 1].effectiveFrom);
          if (criteEF <= previousDate) {
            criteriaError['effectiveFrom'] = 'Effective date should be greater than the previous effective date.'
            hasError = true;
          }
        }
      }
      
      if (crite.customPPSError) {
        criteriaError['customPPSError'] = intl.formatMessage({
          id: "AUTH.VALIDATION.REQUIRED_FIELD"
        });
        hasError = true;
      }

      if (hasError) {
        return criteriaError;
      }

      return false;
    });
    const filtereddrgconfigurationToContractError = drgconfigurationToContractXrefError.filter(value => Object.keys(value).length > 0);

    if (filtereddrgconfigurationToContractError.length > 0) {
      errors['drgconfigurationToContractXref'] = drgconfigurationToContractXrefError;
    }
  }
  
  function validateOPPSConfigurations(values, errors, intl) {
    const contractOppsconfigurationXrefError = values.contractOppsconfigurationXref.map((crite, index) => {
      const criteriaError = {};
      let hasError = false;
      
      if (crite.percentage === '') {
        criteriaError['percentage'] = intl.formatMessage({
          id: "AUTH.VALIDATION.REQUIRED_FIELD"
        });
        hasError = true;
      } else if (parseInt(crite.percentage) < 0) {
        criteriaError['percentage'] = 'Percentage value should be greater than 0'
        hasError = true;
      }
      if (!crite.effectiveFrom) {
        criteriaError['effectiveFrom'] = intl.formatMessage({
          id: "AUTH.VALIDATION.REQUIRED_FIELD"
        });
        hasError = true;
      } else {
        if(index > 0) {
          const criteEF = new Date(crite.effectiveFrom);
          const previousDate = new Date(values.contractOppsconfigurationXref[index - 1].effectiveFrom);
          if (criteEF <= previousDate) {
            criteriaError['effectiveFrom'] = 'Effective date should be greater than the previous effective date.'
            hasError = true;
          }
        }
      }

      if (crite.customPPSError) {
        criteriaError['customPPSError'] = intl.formatMessage({
          id: "AUTH.VALIDATION.REQUIRED_FIELD"
        });
        hasError = true;
      }

      if (hasError) {
        return criteriaError;
      }

      return false;
    });
    const filteredcontractOppsconfigurationXrefErr = contractOppsconfigurationXrefError.filter(value => Object.keys(value).length > 0);

    if (filteredcontractOppsconfigurationXrefErr.length > 0) {
      errors['contractOppsconfigurationXref'] = contractOppsconfigurationXrefError;
    }
  }

  function validateSNFConfigurations(values, errors, intl) {
    const contractSnfconfigurationXrefError = values.contractSnfconfigurationXref.map((crite, index) => {
      const criteriaError = {};
      let hasError = false;
      const drgEffectiveDates = values.drgconfigurationToContractXref.filter(item => item.effectiveFrom).map(item => new Date(item.effectiveFrom));
      
      if (crite.percentage === '') {
        criteriaError['percentage'] = intl.formatMessage({
          id: "AUTH.VALIDATION.REQUIRED_FIELD"
        });
        hasError = true;
      } else if (parseInt(crite.percentage) < 0) {
        criteriaError['percentage'] = 'Percentage value should be greater than 0'
        hasError = true;
      }
      if (!crite.effectiveFrom) {
        criteriaError['effectiveFrom'] = intl.formatMessage({
          id: "AUTH.VALIDATION.REQUIRED_FIELD"
        });
        hasError = true;
      } else {
        if(index > 0) {
          const criteEF = new Date(crite.effectiveFrom);
          const previousDate = new Date(values.contractSnfconfigurationXref[index - 1].effectiveFrom);
          if (criteEF <= previousDate) {
            criteriaError['effectiveFrom'] = 'Effective date should be greater than the previous effective date.'
            hasError = true;
          }
        }

        if (crite.effectiveFrom) {
          const snfDate = new Date(crite.effectiveFrom);
          const isCovered = drgEffectiveDates.some(drgDate => snfDate >= drgDate);
      
          if (!isCovered) {
            criteriaError['effectiveFrom'] = 'Effective date must fall within the active period of an IPPS configuration.';
            hasError = true;
          }
        }
      }

      if (crite.customPPSError) {
        criteriaError['customPPSError'] = intl.formatMessage({
          id: "AUTH.VALIDATION.REQUIRED_FIELD"
        });
        hasError = true;
      }

      if (hasError) {
        return criteriaError;
      }

      return false;
    });
    const filteredcontractSnfconfigurationXrefErr = contractSnfconfigurationXrefError.filter(value => Object.keys(value).length > 0);

    if (filteredcontractSnfconfigurationXrefErr.length > 0) {
      errors['contractSnfconfigurationXref'] = contractSnfconfigurationXrefError;
    }
  }

  function validateEAPGConfigurations(values, errors, intl) {
    const contractEapgconfigurationXrefError =(values.isEAPGSelectionActive && hasEapgAccess) ? values.contractEapgconfigurationXref.map((crite,index) => {
      const criteriaError = {};
      let hasError = false;
      
      if (crite.percentage === '') {
        criteriaError['percentage'] = intl.formatMessage({
          id: "AUTH.VALIDATION.REQUIRED_FIELD"
        });
        hasError = true;
      } else if (parseInt(crite.percentage) < 0) {
        criteriaError['percentage'] = 'Percentage value should be greater than 0'
        hasError = true;
      }

      if (!crite.effectiveFrom) {
        criteriaError['effectiveFrom'] = intl.formatMessage({
          id: "AUTH.VALIDATION.REQUIRED_FIELD"
        });
        hasError = true;
      } else {
        if(index > 0) {
          const criteEF = new Date(crite.effectiveFrom);
          const previousDate = new Date(values.contractEapgconfigurationXref[index - 1].effectiveFrom);
          if (criteEF <= previousDate) {
            criteriaError['effectiveFrom'] = 'Effective date should be greater than the previous effective date.'
            hasError = true;
          }
        }
      }

      if (crite.customEAPGError) {
        criteriaError['customEAPGError'] = intl.formatMessage({
          id: "AUTH.VALIDATION.REQUIRED_FIELD"
        });
        hasError = true;
      }

      if (!crite.claimAmountThreshold) {
          criteriaError["claimAmountThreshold"] = intl.formatMessage({
              id: "AUTH.VALIDATION.REQUIRED_FIELD",
          });
          hasError = true;
      }
      if (parseInt(crite.claimAmountThreshold) < 0) {
          criteriaError["claimAmountThreshold"] =
              "Threshold value should be greater than 0";
          hasError = true;
      }

      if (crite.isScheduled && !crite.schedule) {
        criteriaError["schedule"] = intl.formatMessage({
            id: "AUTH.VALIDATION.REQUIRED_FIELD",
        });
        hasError = true;
      }

      if (!crite.isScheduled && !crite.beginDate) {
        criteriaError["beginDate"] = intl.formatMessage({
            id: "AUTH.VALIDATION.REQUIRED_FIELD",
        });
        hasError = true;
      }
      if (!crite.isScheduled && !crite.endDate) {
        criteriaError["endDate"] = intl.formatMessage({
            id: "AUTH.VALIDATION.REQUIRED_FIELD",
        });
        hasError = true;
      }
      if (!crite.isScheduled && !crite.grouperDescription) {
        criteriaError["grouperDescription"] = intl.formatMessage({
            id: "AUTH.VALIDATION.REQUIRED_FIELD",
        });
        hasError = true;
      }

      if (!crite.isScheduled && (!crite.beginDate || !crite.endDate || !crite.grouperDescription)
        && ((crite.grouperArray && crite.grouperArray.some(grouper => grouper.name || grouper.type || grouper.value))
            || (crite.reimbursementArray && crite.reimbursementArray.some(reimbursement => reimbursement.name || reimbursement.type || reimbursement.value))
      )) {
        criteriaError["eapgSettings"] = 'EAPG settings are required.'
        hasError = true;
      }
      

      if (hasError) {
        return criteriaError;
      }

      return false;
    }):[];
    const filteredcontractEapgconfigurationXrefErr = contractEapgconfigurationXrefError.filter(value => Object.keys(value).length > 0);

    if (filteredcontractEapgconfigurationXrefErr.length > 0) {
      errors['contractEapgconfigurationXref'] = contractEapgconfigurationXrefError;
    }
    checkEapgEffectiveDateWarning(values.effectiveDate, values.contractEapgconfigurationXref);
  }

  function validateIRFConfigurations(values, errors, intl) {
    const contractIrfconfigurationXrefError = values.contractIrfconfigurationXref.map((crite, index) => {
      const criteriaError = {};
      let hasError = false;
      const drgEffectiveDates = values.drgconfigurationToContractXref.filter(item => item.effectiveFrom).map(item => new Date(item.effectiveFrom));
      
      if (crite.percentage === '') {
        criteriaError['percentage'] = intl.formatMessage({
          id: "AUTH.VALIDATION.REQUIRED_FIELD"
        });
        hasError = true;
      } else if (parseInt(crite.percentage) < 0) {
        criteriaError['percentage'] = 'Percentage value should be greater than 0'
        hasError = true;
      }
      if (!crite.effectiveFrom) {
        criteriaError['effectiveFrom'] = intl.formatMessage({
          id: "AUTH.VALIDATION.REQUIRED_FIELD"
        });
        hasError = true;
      } else {
        if(index > 0) {
          const criteEF = new Date(crite.effectiveFrom);
          const previousDate = new Date(values.contractIrfconfigurationXref[index - 1].effectiveFrom);
          if (criteEF <= previousDate) {
            criteriaError['effectiveFrom'] = 'Effective date should be greater than the previous effective date.'
            hasError = true;
          }
        }

        if (crite.effectiveFrom) {
          const irfDate = new Date(crite.effectiveFrom);
          const isCovered = drgEffectiveDates.some(drgDate => irfDate >= drgDate);
      
          if (!isCovered) {
            criteriaError['effectiveFrom'] = 'Effective date must fall within the active period of an IPPS configuration.';
            hasError = true;
          }
        }
      }

      if (crite.customPPSError) {
        criteriaError['customPPSError'] = intl.formatMessage({
          id: "AUTH.VALIDATION.REQUIRED_FIELD"
        });
        hasError = true;
      }

      if (hasError) {
        return criteriaError;
      }

      return false;
    });
    const filteredcontractIrfconfigurationXrefErr = contractIrfconfigurationXrefError.filter(value => Object.keys(value).length > 0);

    if (filteredcontractIrfconfigurationXrefErr.length > 0) {
      errors['contractIrfconfigurationXref'] = contractIrfconfigurationXrefError;
    }
  }

  function validateIPFConfigurations(values, errors, intl) {
    const contractIpfconfigurationXrefError = values.contractIpfconfigurationXref.map((crite, index) => {
      const criteriaError = {};
      let hasError = false;
      const drgEffectiveDates = values.drgconfigurationToContractXref.filter(item => item.effectiveFrom).map(item => new Date(item.effectiveFrom));
      
      if (crite.percentage === '') {
        criteriaError['percentage'] = intl.formatMessage({
          id: "AUTH.VALIDATION.REQUIRED_FIELD"
        });
        hasError = true;
      } else if (parseInt(crite.percentage) < 0) {
        criteriaError['percentage'] = 'Percentage value should be greater than 0'
        hasError = true;
      }
      if (!crite.effectiveFrom) {
        criteriaError['effectiveFrom'] = intl.formatMessage({
          id: "AUTH.VALIDATION.REQUIRED_FIELD"
        });
        hasError = true;
      } else {
        if(index > 0) {
          const criteEF = new Date(crite.effectiveFrom);
          const previousDate = new Date(values.contractIpfconfigurationXref[index - 1].effectiveFrom);
          if (criteEF <= previousDate) {
            criteriaError['effectiveFrom'] = 'Effective date should be greater than the previous effective date.'
            hasError = true;
          }
        }

        if (crite.effectiveFrom) {
          const ipfDate = new Date(crite.effectiveFrom);
          const isCovered = drgEffectiveDates.some(drgDate => ipfDate >= drgDate);
      
          if (!isCovered) {
            criteriaError['effectiveFrom'] = 'Effective date must fall within the active period of an IPPS configuration.';
            hasError = true;
          }
        }
      }

      if (crite.customPPSError) {
        criteriaError['customPPSError'] = intl.formatMessage({
          id: "AUTH.VALIDATION.REQUIRED_FIELD"
        });
        hasError = true;
      }

      if (hasError) {
        return criteriaError;
      }

      return false;
    });
    const filteredcontractIpfconfigurationXrefErr = contractIpfconfigurationXrefError.filter(value => Object.keys(value).length > 0);

    if (filteredcontractIpfconfigurationXrefErr.length > 0) {
      errors['contractIpfconfigurationXref'] = contractIpfconfigurationXrefError;
    }
  }

  function validateLTCHConfigurations(values, errors, intl) {
    const contractLtchConfigurationXrefError = values.contractLtchConfigurationXref.map((crite, index) => {
      const criteriaError = {};
      let hasError = false;
      
      if (crite.percentage === '') {
        criteriaError['percentage'] = intl.formatMessage({
          id: "AUTH.VALIDATION.REQUIRED_FIELD"
        });
        hasError = true;
      } else if (parseInt(crite.percentage) < 0) {
        criteriaError['percentage'] = 'Percentage value should be greater than 0'
        hasError = true;
      }
      if (!crite.effectiveFrom) {
        criteriaError['effectiveFrom'] = intl.formatMessage({
          id: "AUTH.VALIDATION.REQUIRED_FIELD"
        });
        hasError = true;
      } else {
        if(index > 0) {
          const criteEF = new Date(crite.effectiveFrom);
          const previousDate = new Date(values.contractLtchConfigurationXref[index - 1].effectiveFrom);
          if (criteEF <= previousDate) {
            criteriaError['effectiveFrom'] = 'Effective date should be greater than the previous effective date.'
            hasError = true;
          }
        }
      }

      if (crite.customPPSError) {
        criteriaError['customPPSError'] = intl.formatMessage({
          id: "AUTH.VALIDATION.REQUIRED_FIELD"
        });
        hasError = true;
      }

      if (hasError) {
        return criteriaError;
      }

      return false;
    });
    const filteredcontractLtchConfigurationXrefErr = contractLtchConfigurationXrefError.filter(value => Object.keys(value).length > 0);

    if (filteredcontractLtchConfigurationXrefErr.length > 0) {
      errors['contractLtchConfigurationXref'] = contractLtchConfigurationXrefError;
    }
  }

  function validatePricerStats(values, errors, intl) {
    const isOutpatientExist = values.contractPricerStatsConfigurationXRef.some(ps => ps.type === 'OUTPATIENT');
    const contractPricerStatsConfigurationXRefError = values.contractPricerStatsConfigurationXRef.map((crite, index) => {
      const criteriaError = {};
      let hasError = false;
      
      if (!crite.type || !crite.type?.trim()) {
        criteriaError['type'] = intl.formatMessage({
          id: "AUTH.VALIDATION.REQUIRED_FIELD"
        });
        hasError = true;
      }

      if (!crite.note || !crite.note?.trim()) {
        criteriaError['note'] = intl.formatMessage({
          id: "AUTH.VALIDATION.REQUIRED_FIELD"
        });
        hasError = true;
      }

      if (!crite.algorithmDescription || !crite.algorithmDescription?.trim()) {
        criteriaError['algorithmDescription'] = intl.formatMessage({
          id: "AUTH.VALIDATION.REQUIRED_FIELD"
        });
        hasError = true;
      }

      if (hasError) {
        return criteriaError;
      }

      return false;
    });

    if (values.isEAPGSelectionActive && values.contractPricerStatsConfigurationXRef.length > 0 && !isOutpatientExist) {
      contractPricerStatsConfigurationXRefError[0] = {
        ...(contractPricerStatsConfigurationXRefError[0] || {}),
        type: "Outpatient pricer stats are required for EAPG"
      };
    }
    
    const filteredContractPricerStatsConfigurationXRefErr = contractPricerStatsConfigurationXRefError.filter(value => Object.keys(value).length > 0);

    if (filteredContractPricerStatsConfigurationXRefErr.length > 0) {
      errors['contractPricerStatsConfigurationXRef'] = contractPricerStatsConfigurationXRefError;
    }
  }

  return (
    <>
      { directoryId &&    
        <ContractsBreadCrumb directoryId={directoryId} isEdit={isEdit} />
      }    
      
      <Loadable loading={contractsGetPending || contractsCreatePending || contractsUpdatePending}>
      <Formik
        enableReinitialize={true}
        initialValues={initialValues}
        innerRef={formikRef}
        validate={values => {
          const errors: Record<string,string> = {};

          if (!values.name) {
            errors.name = intl.formatMessage({
              id: "AUTH.VALIDATION.REQUIRED_FIELD"
            });
          }

          if (!values.effectiveDate) {
            errors.effectiveDate = intl.formatMessage({
              id: "AUTH.VALIDATION.REQUIRED_FIELD"
            });
          }
          if (!values.terminationDate) {
            errors.terminationDate = intl.formatMessage({
              id: "AUTH.VALIDATION.REQUIRED_FIELD"
            });
          }

          if( values.effectiveDate > values.terminationDate) {
            errors.terminationDate = 'Termination date should be greater than effective date';
            errors.effectiveDate = 'Effective date should be less than termination date';
          }

          if(values.isEAPGSelectionActive && !values.usePricerStats) {
            errors.usePricerStats = 'It is required to use Pricer Stats when using EAPG';
          }

          // Contract Selection Criteria Error
          const contractCriteriaError = values.contractSelectionCriteriaXref.map((crite,index) => {
            const criteriaError = {};
            let hasError = false;
            if (crite.contractSelectionCriteriaId !== null) {
              if (!crite.equator) {
                criteriaError['equator'] = intl.formatMessage({
                  id: "AUTH.VALIDATION.REQUIRED_FIELD"
                });
                hasError = true;
              }
              if (crite.isBetween) {
                if (!crite.startsAt) {
                  criteriaError['startsAt'] = intl.formatMessage({
                    id: "AUTH.VALIDATION.REQUIRED_FIELD"
                  });
                  hasError = true;
                }
                if (!crite.endsAt) {
                  criteriaError['endsAt'] = intl.formatMessage({
                    id: "AUTH.VALIDATION.REQUIRED_FIELD"
                  });
                  hasError = true;
                }
              } else {
                if (!crite.value) {
                  criteriaError['value'] = intl.formatMessage({
                    id: "AUTH.VALIDATION.REQUIRED_FIELD"
                  });
                  hasError = true;
                }
              }
              
              if(crite.contractSelectionCriteriaId.id === 5 && crite.value && values.contractSelectionCriteriaXref?.some((x, ind) => index !== ind && x.ruleSelectionCriteriaId?.id === 5 && x.value == crite.value)) {
                criteriaError['value'] = "Duplicate selection criteria are not allowed.";
                hasError = true;
              }

              for (let i = index - 1; i >= 0; i--) {
                  const previous = values.contractSelectionCriteriaXref[i];
                  const doesCriteriaNameMatces =
                      crite.contractSelectionCriteriaId?.name ===
                      previous.contractSelectionCriteriaId?.name;
                  const validationMsg =
                      "Duplicate selection criteria are not allowed. Please review your input";

                  if (
                      crite.isBetween &&
                      previous.isBetween &&
                      crite.startsAt === previous.startsAt &&
                      crite.endsAt === previous.endsAt &&
                      doesCriteriaNameMatces
                  ) {
                      criteriaError["startsAt"] = validationMsg;
                      hasError = true;
                      break;
                  } else if (
                      crite.value === previous.value &&
                      crite.equator === previous.equator &&
                      crite.contractSelectionCriteriaId?.name ===
                          previous.contractSelectionCriteriaId?.name
                  ) {
                      criteriaError["value"] = validationMsg;
                      hasError = true;
                      break;
                  }
              }

            }

            if (hasError) {
              return criteriaError;
            }

            return false;
          });
          const filteredCriteriaError = contractCriteriaError.filter(value => Object.keys(value).length > 0);

          if (filteredCriteriaError.length > 0 && values.isCriteriaActive) {
            errors['contractSelectionCriteriaXref'] = contractCriteriaError;
          }

          const contractOverrideGroupError = values.contractOverrideGroupXref?.map((group, groupIndex) => {
            let hasGroupError = false;
            const criteriaGroupError:any = {};

            // Skip completely empty groups
            const isGroupEmpty = !group.overrideContractId && group.contractOverrideCriteriaXref?.every(crite => !crite.contractOverrideCriteriaId && !crite.equator && !crite.value && !crite.startsAt && !crite.endsAt);
            if (isGroupEmpty) {
              return undefined;
            }

            // Override Contract validation
            if (!group.overrideContractId) {
              criteriaGroupError.overrideContractId = intl.formatMessage({
                id: "AUTH.VALIDATION.REQUIRED_FIELD",
              });
              hasGroupError = true;
            }

            if (mode === 'edit' && group.overrideContractId && group.overrideContractId.id === values.id) {
              criteriaGroupError.overrideContractId = "Same contract is not allowed.";
              hasGroupError = true;
            }

            // Criteria-level validation
            const overrideCriteriaError =
              group.contractOverrideCriteriaXref?.map((crite, index) => {
                let hasCriteriaError = false;
                const criteriaError:any = {};

                if (crite.contractOverrideCriteriaId) {
                  if (!crite.equator && crite.contractOverrideCriteriaId.id !== 5 && crite.contractOverrideCriteriaId.id !== 6) {
                    criteriaError.equator = intl.formatMessage({
                      id: "AUTH.VALIDATION.REQUIRED_FIELD",
                    });
                    hasCriteriaError = true;
                  }

                  if (crite.isBetween) {
                    if (!crite.startsAt) {
                      criteriaError.startsAt = intl.formatMessage({
                        id: "AUTH.VALIDATION.REQUIRED_FIELD",
                      });
                      hasCriteriaError = true;
                    }
                    if (!crite.endsAt) {
                      criteriaError.endsAt = intl.formatMessage({
                        id: "AUTH.VALIDATION.REQUIRED_FIELD",
                      });
                      hasCriteriaError = true;
                    }
                  } else {
                    if (!crite.value) {
                      criteriaError.value = intl.formatMessage({
                        id: "AUTH.VALIDATION.REQUIRED_FIELD",
                      });
                      hasCriteriaError = true;
                    }
                  }

                  // Duplicate facility (id === 5) validation
                  if (crite.contractOverrideCriteriaId.id === 5 && crite.value && group.contractOverrideCriteriaXref.some((x, ind) => ind !== index && x.contractOverrideCriteriaId?.id === 5 && x.value === crite.value)) {
                    criteriaError.value = "Duplicate override criteria are not allowed.";
                    hasCriteriaError = true;
                  }

                  // Duplicate Provider Role (id === 6) validation
                  if (crite.contractOverrideCriteriaId.id === 6 && crite.value && group.contractOverrideCriteriaXref.some((x, ind) => ind !== index && x.contractOverrideCriteriaId?.id === 6 && x.value === crite.value)) {
                    criteriaError.value = "Duplicate override criteria are not allowed.";
                    hasCriteriaError = true;
                  }

                  // Duplicate criteria validation (previous rows only)
                  for (let i = index - 1; i >= 0; i--) {
                    const previous = group.contractOverrideCriteriaXref[i];
                    const sameCriteria = crite.contractOverrideCriteriaId?.name === previous.contractOverrideCriteriaId?.name;
                    const validationMsg = "Duplicate override criteria are not allowed. Please review your input";

                    if (crite.isBetween && previous.isBetween && crite.startsAt === previous.startsAt && crite.endsAt === previous.endsAt && sameCriteria) {
                      criteriaError.startsAt = validationMsg;
                      hasCriteriaError = true;
                      break;
                    }

                    if (crite.value === previous.value && crite.equator === previous.equator && sameCriteria) {
                      criteriaError.value = validationMsg;
                      hasCriteriaError = true;
                      break;
                    }
                  }
                }

                if (hasCriteriaError) {
                  hasGroupError = true;
                  return criteriaError;
                }

                return undefined;
              });

            if (hasGroupError) {
              criteriaGroupError.contractOverrideCriteriaXref = overrideCriteriaError;
              return criteriaGroupError;
            }

            return undefined;
          }) || [];

          const filteredOverrideGroupError = contractOverrideGroupError?.filter(Boolean);

          if (filteredOverrideGroupError.length > 0 && values.isOverrideCriteriaActive) {
            errors['contractOverrideGroupXref'] = contractOverrideGroupError;
          }

          if (values.contractPatientResponsibilityXref.length === 0) {
            errors.contractPatientResponsibilityXref = intl.formatMessage({
              id: "AUTH.VALIDATION.REQUIRED_FIELD"
            });
          }

          if(values.isNonCoveredCodeActive && values.contractPatientResponsibilityXref.length > 0 && values.contractNonCoveredXref.length > 0) {
            const duplicates = values.contractPatientResponsibilityXref.some(pr => values.contractNonCoveredXref.some(oa => pr.code === oa.code));
            if (duplicates) {
              errors.contractNonCoveredXref = intl.formatMessage({
                id: "AUTH.VALIDATION.REQUIRED_FIELD"
              });
            }
          }

          if(values.isAllowableCodeActive && values.contractPatientResponsibilityXref.length > 0 && values.contractOtherAllowableXref.length > 0) {
            const duplicates = values.contractPatientResponsibilityXref.some(pr => values.contractOtherAllowableXref.some(oa => pr.code === oa.code));
            if (duplicates) {
              errors.contractOtherAllowableXref = intl.formatMessage({
                id: "AUTH.VALIDATION.REQUIRED_FIELD"
              });
            }
          }

          if(values.IPPSSectionEnabled) {
            validateIPPSConfigurations(values, errors, intl);
          }

          if(values.OPPSSectionEnabled && !values.isEAPGSelectionActive) {
            validateOPPSConfigurations(values, errors, intl);
          }

          if(values.SNFSectionEnabled) {
            validateSNFConfigurations(values, errors, intl);
          }

          if(values.EAPGSectionEnabled && values.isEAPGSelectionActive) {
            validateEAPGConfigurations(values, errors, intl);
          }

          if(values.IRFSectionEnabled) {
            validateIRFConfigurations(values, errors, intl);
          }

          if(values.IPFSectionEnabled) {
            validateIPFConfigurations(values, errors, intl);
          }

          if(values.LTCHSectionEnabled) {
            validateLTCHConfigurations(values, errors, intl);
          }

          if(values.usePricerStats) {
            validatePricerStats(values, errors, intl);
          }

          return errors;
        }}
        onSubmit={(values) => {
          let payload:any = {
            facilityIds :
              values.facilityIds && values.facilityIds.length > 0 ?
                values.facilityIds.map(facility => facility.id) 
                : [],

            alertContactIds :
              values.alertContacts && values.alertContacts.length > 0 ?
                values.alertContacts.map(contact => contact.id) 
                : [],
            
            contractDenialCascodeXref : 
              values.isDenialCasCodeActive ? 
                values.contractDenialCascodeXref.map(item => item.id) 
                : [],

            contractSelectionCriteriaXref :
              values.isCriteriaActive ?
                values.contractSelectionCriteriaXref
                  .filter(x => x.contractSelectionCriteriaId !== null || x.equator !== '' || x.value !== '')
                  .map(item => 
                    item.isBetween ?
                      {
                        contractSelectionCriteriaId: item.contractSelectionCriteriaId.id,
                        equator: item.equator,
                        value: `${item.startsAt}&${item.endsAt}`
                      }
                    :
                      {
                        contractSelectionCriteriaId: item.contractSelectionCriteriaId.id,
                        equator: item.equator,
                        value: item.value
                      }
                  )
                : [],

            contractOverrideGroupXref: values.isOverrideCriteriaActive
            ? values.contractOverrideGroupXref?.filter(x=> x.overrideContractId !== null)?.map(group => ({
                overrideContractId: group.overrideContractId?.id,
                contractOverrideCriteriaXref: group.contractOverrideCriteriaXref
                  .filter(x => x.contractOverrideCriteriaId !== null || x.equator !== '' || x.value !== '')
                  .map(item =>
                    item.isBetween
                      ? {
                          contractOverrideCriteriaId: item.contractOverrideCriteriaId?.id,
                          equator: item.equator,
                          value: `${item.startsAt}&${item.endsAt}`,
                        }
                      : {
                          contractOverrideCriteriaId: item.contractOverrideCriteriaId?.id,
                          equator: item.equator === '' ? 'equals' : item.equator,
                          value: item.value,
                        }
                  ),
              }))
            : [],
            drgconfigurationToContractXref:
              (values.isPpsSelectionActive && values.IPPSSectionEnabled) ?
                values.drgconfigurationToContractXref
                  .filter(item => item.effectiveFrom !== null && item.effectiveFrom !== "").
                  map(item => ({ 
                    drgConfigurationId: item.drgConfigurationId?.id ?? null, 
                    percentage: parseInt(item.percentage), 
                    effectiveFrom: item.effectiveFrom, 
                    includeIME: item.includeIME,
                    includeDSH: item.includeDSH,
                    lesserOf: item.lesserOf
                  }))
                : [],

            contractOppsconfigurationXref:
              (values.isPpsSelectionActive && values.OPPSSectionEnabled && !values.isEAPGSelectionActive) ?
                values.contractOppsconfigurationXref
                  .filter(item => item.effectiveFrom !== null && item.effectiveFrom !== "")
                  .map(item => ({ 
                    oppsConfigurationId: item.oppsConfigurationId?.id ?? null, 
                    percentage: parseInt(item.percentage), 
                    effectiveFrom: item.effectiveFrom,
                    lesserOf: item.lesserOf
                  }))
                : [],

            contractSnfconfigurationXref:
              (values.isPpsSelectionActive && values.SNFSectionEnabled) ?
                values.contractSnfconfigurationXref
                  .filter(item => item.effectiveFrom !== null && item.effectiveFrom !== "")
                  .map(item => ({ 
                    percentage: parseInt(item.percentage), 
                    effectiveFrom: item.effectiveFrom
                  }))
                : [],

            contractEapgconfigurationXref:
              (values.isEAPGSelectionActive && values.EAPGSectionEnabled && hasEapgAccess) ?
                values.contractEapgconfigurationXref .filter(item => item.effectiveFrom !== null && item.effectiveFrom !== "")
                  .map(item => ({ 
                    eapgConfigurationId: item.eapgConfigurationId, 
                    percentage: parseInt(item.percentage), 
                    effectiveFrom: item.effectiveFrom ,
                    claimAmountThreshold: item?.claimAmountThreshold,
                    isScheduled: item?.isScheduled,
                    schedule: item?.isScheduled == true ? item?.schedule : null,
                    settingsJson: item?.isScheduled == false && item?.eapgSettings ? JSON.stringify(item.eapgSettings): null
                  }))
                : [],

            contractIrfconfigurationXref:
            (values.isPpsSelectionActive && values.IRFSectionEnabled) ?
              values.contractIrfconfigurationXref
                .filter(item => item.effectiveFrom !== null && item.effectiveFrom !== "")
                .map(item => ({ 
                  percentage: parseInt(item.percentage), 
                  effectiveFrom: item.effectiveFrom
                }))
              : [],

            contractIpfconfigurationXref:
            (values.isPpsSelectionActive && values.IPFSectionEnabled) ?
              values.contractIpfconfigurationXref
                .filter(item => item.effectiveFrom !== null && item.effectiveFrom !== "")
                .map(item => ({ 
                  percentage: parseInt(item.percentage), 
                  effectiveFrom: item.effectiveFrom
                }))
              : [],

            contractLtchConfigurationXref:
            (values.isPpsSelectionActive && values.LTCHSectionEnabled) ?
              values.contractLtchConfigurationXref
                .filter(item => item.effectiveFrom !== null && item.effectiveFrom !== "")
                .map(item => ({ 
                  percentage: parseInt(item.percentage), 
                  effectiveFrom: item.effectiveFrom
                }))
              : [],
            
            contractPricerStatsConfigurationXRef:
            values.usePricerStats ?
              values.contractPricerStatsConfigurationXRef
                .filter(item => item.type !== null && item.type !== "")
                .map(item => ({ 
                  type: item.type?.trim(), 
                  note: item.note?.trim(),
                  algorithmDescription: item.algorithmDescription?.trim()
                }))
              : [],

            id : undefined,
            renew : undefined,
            alert : undefined,
            name: values.name,
            effectiveDate: values.effectiveDate,
            terminationDate: values.terminationDate,
            isPayer: values.isPayer === "true" ? true : false,
            description: values.description,
            notification: values.notification,
            vendorContacts: values.vendorContacts,
            expectedDaysToPay: values.expectedDaysToPay === '' ? null : values.expectedDaysToPay,
            contractStateId: values.contractStateId,
            contractOtherAllowableXref: [
              ...values.contractPatientResponsibilityXref
                  .map(item => ({ cascodeId: item.id, isPR: true, isNonCovered: false })),
            
              ...(values.isAllowableCodeActive
                ? values.contractOtherAllowableXref
                    .map(item => ({ cascodeId: item.id, isPR: false, isNonCovered: false }))
                : []),
            
              ...(values.isNonCoveredCodeActive
                ? values.contractNonCoveredXref
                    .map(item => ({ cascodeId: item.id, isPR: false, isNonCovered: true }))
                : [])
            ],
            excludePatientRespInAllowable:values?.excludePatientRespInAllowable,
            ignorePayerClaimControlNumberOnReversal:values?.ignorePayerClaimControlNumberOnReversal,
            usePricerStats:values?.usePricerStats
          }

          if(directoryId && directoryId!=="root")
          {
            payload={...payload,
            contractDirectoryId:directoryId
            }
            

          }

          if (mode === 'create') {
            contractCreate(payload, handleCallback);
          }
          else {
            payload = {
              ...payload,
              id: values.id,
              renew: values.renew,
              alert: values.alert,
              vendorContacts: values.vendorContacts.map(contact => (
                {
                  ...contact,
                  contractId: contractId
                }
              )),
            }
            contractUpdate(values.id, payload, handleEditCallback);
          }
        }
        }
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
          setFieldValue,
          dirty
        }) => (
          <form onSubmit={handleSubmit} noValidate autoComplete="off" className={classes.container}>
            <Portlet>
              <PortletHeader
                title={`${isEdit ? 'Edit' : 'Add'} Contract`}
                toolbar={
                  <PortletHeaderToolbar>
                    <BackButton defaultRoute={`/cms/contract/view/${contractId}${directoryId ? `/${directoryId}`:''}`} />
                    {mode === 'edit' && <Tooltip title="Redirects you to the view page of this contract">
                      <Button
                        variant="contained"
                        className='ml-3'
                        type="button"
                        onClick={handleRedirectToContractView}
                      >
                        Contract View 
                      </Button>
                    </Tooltip>}
                    <Button
                      variant="contained"
                      color="primary"
                      className='ml-3'
                      type="submit"
                      disabled={contractsCreatePending || contractsUpdatePending || (!dirty && isEdit)}
                    >
                      Save
                    </Button>
                  </PortletHeaderToolbar>
                }
              />
              <PortletBody>
                <div className="root">
                  <Grid container>
                    <Grid item xs={9}>
                      <Grid container>
                        <Grid item xs={6}>
                          <TextField
                            required
                            label="Name"
                            name="name"
                            className={classes.textField}
                            margin="normal"
                            onBlur={handleBlur}
                            onChange={handleChange}
                            value={values.name}
                            helperText={touched.name && errors.name}
                            error={Boolean(touched.name && errors.name)}
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                    <Grid item xs={9}>
                      <Grid container>
                        <Grid item xs={6}>
                          <TextField
                            type="date"
                            label="Effective Date"
                            name="effectiveDate"
                            className={classes.textField}
                            margin="normal"
                            onBlur={handleBlur}
                            onChange={handleChange}
                            value={values.effectiveDate}
                            helperText={touched.effectiveDate && errors.effectiveDate}
                            error={Boolean(touched.effectiveDate && errors.effectiveDate)}
                            InputLabelProps={{
                              shrink: true,
                            }}
                          />
                        </Grid>
                        <Grid item xs={6}>
                          <TextField
                            type="date"
                            label="Termination Date"
                            name="terminationDate"
                            className={classes.textField}
                            margin="normal"
                            onBlur={handleBlur}
                            onChange={handleChange}
                            value={values.terminationDate}
                            helperText={touched.terminationDate && errors.terminationDate}
                            error={Boolean(touched.terminationDate && errors.terminationDate)}
                            InputLabelProps={{
                              shrink: true,
                            }}
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                    {mode === 'edit' && (
                      <Grid item xs={9}>
                        <Grid container>
                          <Grid item xs={6}>
                            <TextField
                              type="date"
                              label="Renew"
                              name="renew"
                              className={classes.textField}
                              margin="normal"
                              onBlur={handleBlur}
                              onChange={handleChange}
                              value={values.renew}
                              helperText={touched.renew && errors.renew}
                              error={Boolean(touched.renew && errors.renew)}
                              InputLabelProps={{
                                shrink: true,
                              }}
                            />
                          </Grid>
                          {/* <Grid item xs={6}>
                            <TextField
                              type="date"
                              label="Alert"
                              name="alert"
                              className={classes.textField}
                              margin="normal"
                              onBlur={handleBlur}
                              onChange={handleChange}
                              value={values.alert}
                              helperText={touched.alert && errors.alert}
                              error={Boolean(touched.alert && errors.alert)}
                              InputLabelProps={{
                                shrink: true,
                              }}
                            />
                          </Grid> */}
                        </Grid>
                      </Grid>
                    )}
                    <Grid item xs={9}>
                      <Grid container>
                        <Grid item xs={6}>
                          <TextField
                            type="text"
                            multiline
                            rows={3}
                            label="Description"
                            name="description"
                            className={classes.description}
                            margin="normal"
                            onBlur={handleBlur}
                            onChange={handleChange}
                            value={values.description}
                            helperText={(touched.description && errors.description) ?? 'This description is used in the MRF as additional notes.'}
                            error={Boolean(touched.description && errors.description)}
                            InputLabelProps={{
                              shrink: true,
                            }}
                          />
                        </Grid>

                        <Grid item xs={6}>
                          <FormControl className={classes.facilityFormControlAuto}>
                            <Autocomplete
                              onChange={(e, value) => setFieldValue("facilityIds", value)}
                              filterOptions={facilityFilterOption}
                              value={values.facilityIds}
                              multiple
                              options={facilities}
                              disableCloseOnSelect
                              getOptionLabel={(option) => option.name}
                              getOptionDisabled={option => {
                                if (!option.active) {
                                  const temp = values.facilityIds.find(item => item.id === option.id);
                                  return temp ? false : true
                                }
                                return false
                              }}
                              renderOption={(props, option, { selected }) => {
                                return (
                                  <li {...props}>
                                    <Checkbox
                                      icon={icon}
                                      checkedIcon={checkedIcon}
                                      style={{ marginRight: 8 }}
                                      checked={selected}
                                    />
                                    <span className={!option.active && 'text-muted'}> {option.name}</span>
                                  </li>
                                )
                              }}
                              renderTags={(tagValue, getTagProps) => {
                                const numTags = tagValue.length;
                                return (
                                  <Typography variant="caption">
                                    {tagValue.slice(0, 2).map((option, index) => (
                                      <Chip
                                        size="small"
                                        color={option.active ? "secondary" : "default"}
                                        key={index}
                                        label={option.name}
                                        {...getTagProps({ index })}
                                      />
                                    ))}
                                    {numTags > 2 && ` +${numTags - 2}`}
                                  </Typography>
                                )
                              }
                              }
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  label="Facilities"
                                />
                              )}
                            />
                          </FormControl>
                        </Grid>
                        <Grid item xs={6}>
                          <TextField
                            label="Expected Days to Pay"
                            name="expectedDaysToPay"
                            className={classes.textField}
                            margin="normal"
                            onBlur={handleBlur}
                            onChange={handleChange}
                            type='number'
                            value={values.expectedDaysToPay}
                            helperText={touched.expectedDaysToPay && errors.expectedDaysToPay}
                            error={Boolean(touched.expectedDaysToPay && errors.expectedDaysToPay)}
                          />
                        </Grid>
                        <Grid item xs={6}>
                          <FormControl className={classes.formControlDropdown}>
                            <InputLabel htmlFor="contractStateId">Contract State</InputLabel>
                            <Select
                              required
                              value={values.contractStateId}
                              onChange={handleChange}
                              error={Boolean(touched.contractStateId && errors.contractStateId)}
                              input={<Input id="contractStateId" />}
                              inputProps={{
                                name: "contractStateId",
                                id: "contractStateId"
                              }}
                            >
                              {contractsStates.map(state => (
                                <MenuItem
                                  key={state.id}
                                  value={state.id}
                                >
                                  {state.name}
                                </MenuItem>
                              ))}
                            </Select>
                            <FormHelperText error>{touched.contractStateId && errors.contractStateId}</FormHelperText>
                          </FormControl>
                        </Grid>
                        <Grid item xs={6}>
                          <TextField
                            type="text"
                            label="Finalized Date"
                            name="finalizedDate"
                            className={classes.textField}
                            margin="normal"
                            value={values.finalizedDate}
                            disabled={true}
                            InputLabelProps={{
                              shrink: true,
                            }}
                          />
                        </Grid>
                        <Grid item xs={12}>
                            { isEdit && (
                              <>
                                <Button
                                  variant="contained"
                                  color="primary"
                                  className='mr-2'
                                  onClick={handleOpenNotes}
                                >
                                  View Notes ({notesCount || 0})
                                </Button>

                                <Button
                                  variant="contained"
                                  color="primary"
                                  onClick={() => setAuditLogsOpen(true)}
                                >
                                  Audit Logs View
                                </Button>
                              </>
                            )}
                          </Grid>
                      </Grid>

                    </Grid >
                    <Grid item xs={9}>
                      <Grid container className="mt-4">
                        {/* <Grid item xs={6}>
                          <FormGroup>
                            <Typography component="div">
                              <Grid component="label" container alignItems="center" spacing={0}>
                                <Grid item>
                                  <FormControl>
                                    <FormLabel>Contract Type</FormLabel>
                                    <RadioGroup
                                      className={classes.group}
                                      row
                                      aria-label="isPayer"
                                      name="isPayer"
                                      value={values.isPayer}
                                      onChange={handleChange}

                                    >
                                      <FormControlLabel
                                        value="true"
                                        control={<Radio />}
                                        label="Payer"
                                        disabled={isEdit}
                                      />
                                      <FormControlLabel
                                        value="false"
                                        control={<Radio />}
                                        label="Vendor"
                                        disabled={isEdit}
                                      />
                                    </RadioGroup>
                                  </FormControl>
                                </Grid>
                              </Grid>
                            </Typography>
                          </FormGroup>
                        </Grid> */}
                       
                        <Grid item xs={2}>
                          <FormControlLabel
                            control={
                              <Switch
                                name="isCriteriaActive"
                                color="primary"
                                checked={values.isCriteriaActive}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                className={classes.switch}
                                value={values.isCriteriaActive}
                              />
                            }
                            label="Criteria"
                          />
                        </Grid>
                        <Grid item xs={3}>
                          <FormControlLabel
                            control={
                              <Switch
                                name="isOverrideCriteriaActive"
                                color="primary"
                                checked={values.isOverrideCriteriaActive}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                className={classes.switch}
                                value={values.isOverrideCriteriaActive}
                              />
                            }
                            label="Contract Override"
                          />
                        </Grid>
                        <Grid item xs={2}>
                          <FormControlLabel
                            control={
                              <Switch
                                name="isDenialCasCodeActive"
                                color="primary"
                                checked={values.isDenialCasCodeActive}
                                onChange={(e) => handleDenialCasCodeToggleChange(e, setFieldValue)}
                                onBlur={handleBlur}
                                className={classes.switch}
                                value={values.isDenialCasCodeActive}
                              />
                            }
                            label="Denial Codes"
                          />
                        </Grid>
                        <Grid item xs={2}>
                          <FormControlLabel
                            control={
                              <Switch
                                name="isAllowableCodeActive"
                                color="primary"
                                checked={values.isAllowableCodeActive}
                                onChange={(e) => handleAllowableToggleChange(e, setFieldValue)}
                                onBlur={handleBlur}
                                className={classes.switch}
                                value={values.isAllowableCodeActive}
                              />
                            }
                            label="Other Allowable"
                          />
                        </Grid>

                        <Grid item xs={2}>
                          <FormControlLabel
                            control={
                              <Switch
                                name="isPpsSelectionActive"
                                color="primary"
                                checked={values.isPpsSelectionActive}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                className={classes.switch}
                                value={values.isPpsSelectionActive}
                              />
                            }
                            label="Medicare PPS"
                          />
                        </Grid>
                       {hasEapgAccess && <Grid item xs={1}>
                          <FormControlLabel
                            control={
                              <Switch
                                name="isEAPGSelectionActive"
                                color="primary"
                                checked={values.isEAPGSelectionActive}
                                onChange={(e) => {
                                  const checked = e.target.checked;
                                  if (checked) {
                                    setFieldValue("isEAPGSelectionActive", true);
                                    setFieldValue("usePricerStats", true);
                                    setFieldValue("OPPSSectionEnabled", false);
                                  }
                                  else {
                                    setFieldValue("isEAPGSelectionActive", checked);
                                  }
                                }}
                                onBlur={handleBlur}
                                className={classes.switch}
                                value={values.isEAPGSelectionActive}
                              />
                            }
                            label="EAPG"
                          />
                        </Grid>}
                        <Grid item xs={5}>
                          <FormControlLabel
                            control={
                              <Switch
                                name="excludePatientRespInAllowable"
                                color="primary"
                                checked={values.excludePatientRespInAllowable}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                className={classes.switch}
                                value={values.excludePatientRespInAllowable}
                              />
                            }
                            label="Exclude Full Patient Responsibility in Allowables"
                          />
                        </Grid>
                        <Grid item xs={5}>
                          <FormControlLabel
                            control={
                              <Switch
                                name="ignorePayerClaimControlNumberOnReversal"
                                color="primary"
                                checked={values.ignorePayerClaimControlNumberOnReversal}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                className={classes.switch}
                                value={values.ignorePayerClaimControlNumberOnReversal}
                              />
                            }
                            label="Ignore Payer Claim Control Number On Reversal"
                          />
                          <span className={classes.helpClass}>
                            {hoverColumn('For this contract, the payer does not use the same claim control number when sending payment reversals. Turning this on tells the system to ignore the control number and match reversals using service dates, total charges, and payment amounts instead.')}
                          </span>
                        </Grid>
                        <Grid item xs={2}>
                          <FormControlLabel
                            control={
                              <Switch
                                name="isNonCoveredCodeActive"
                                color="primary"
                                checked={values.isNonCoveredCodeActive}
                                onChange={(e) => setFieldValue('isNonCoveredCodeActive', e.target.checked)}
                                onBlur={handleBlur}
                                className={classes.switch}
                                value={values.isNonCoveredCodeActive}
                              />
                            }
                            label="Non-Covered"
                          />
                        </Grid>

                         <Grid item xs={5}>
                          <FormControlLabel
                            control={
                              <Switch
                                name="usePricerStats"
                                color="primary"
                                checked={values.usePricerStats}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                className={classes.switch}
                                value={values.usePricerStats}
                              />
                            }
                            label="Use Pricer Stats"
                          />
                          <FormHelperText error>{errors.usePricerStats}</FormHelperText>
                          </Grid>
                      </Grid>
                    </Grid>
                    {values.usePricerStats &&
                      <Grid item xs={10} className="mt-3">
                        <Card>
                          <Card.Header as="h5">Pricer Stats</Card.Header>
                          <Card.Body>
                            <ContractPricerStatsFieldArray
                              values={values}
                              touched={touched}
                              errors={errors}
                              setFieldValue={setFieldValue}
                              disabled={!values.usePricerStats}
                            />
                          </Card.Body>
                        </Card>
                      </Grid>
                    }
                    <Grid item xs={10} className="mt-3">
                      <Card>
                        <Card.Header as="h5" className={`${Boolean((touched.contractPatientResponsibilityXref && errors.contractPatientResponsibilityXref) || errors.contractOtherAllowableXref) && classes.redColor}`}>Patient Responsibility
                          {Boolean(touched.contractPatientResponsibilityXref && errors.contractPatientResponsibilityXref) && <span className={classes.errorText}> (Please select at least one patient responsibility)</span>}
                          {Boolean(errors.contractOtherAllowableXref) && <span className={classes.errorText}> (Patient responsibility codes cannot be used for Other Allowables.)</span>}
                        </Card.Header>
                        <Card.Body>
                          <ContractPatientResponsibilitySelection
                            values={values}
                            casCodes={casCodes}
                            setFieldValue={setFieldValue}
                          />
                        </Card.Body>
                      </Card>
                    </Grid>
                    {values.isNonCoveredCodeActive &&
                      <Grid item xs={10} className="mt-3">
                        <Card>
                          <Card.Header as="h5" className={`${Boolean(errors.contractNonCoveredXref) && classes.redColor} d-flex justify-content-between align-items-center`}>
                            <span>
                              Non-Covered
                              {Boolean(errors.contractNonCoveredXref) && (
                                <span className={classes.errorText}>
                                  {" "}
                                  (Non-Covered codes cannot be used for Patient responsibility.)
                                </span>
                              )}
                            </span>
                            <span className={classes.helpClass}>
                              {hoverColumn('Group Code: PR')}
                            </span>
                          </Card.Header>
                          <Card.Body>
                            <ContractNonCoveredSelection
                              values={values}
                              casCodes={casCodes}
                              setFieldValue={setFieldValue}
                            />
                          </Card.Body>
                        </Card>
                      </Grid>
                    }
                    {values.isOverrideCriteriaActive &&
                      <Grid item xs={10} className="mt-3">
                        <Card>
                          <Card.Header as="div" style={{ display: "flex", justifyContent: "space-between",alignItems: "center"}}>
                            <Typography variant='h6'>Contract Override</Typography>
                            <Button
                              color="primary"
                              variant="contained"
                              startIcon={<AddCircleIcon />}
                              onClick={() =>
                                setFieldValue("contractOverrideGroupXref",
                                  [
                                    ...values.contractOverrideGroupXref,
                                    {
                                      overrideContractId: null,
                                      contractOverrideCriteriaXref: [
                                          {
                                              contractOverrideCriteriaId: null,
                                              equator: '',
                                              value: ''
                                          }
                                      ]
                                    }
                                  ]
                                )
                              }
                            >
                              New Override
                            </Button>
                          </Card.Header>
                          <Card.Body>
                            <ContractOverrideGroupFieldArray
                              values={values}
                              contractOverrideCriteria={contractOverrideCriteria}
                              handleChange={handleChange}
                              handleBlur={handleBlur}
                              touched={touched}
                              errors={errors}
                              setFieldValue={setFieldValue}
                              npiRoles={npiRoles}
                              disabled={false}
                              tinyContracts={tinyContracts}
                              facilities={facilities}
                            />
                          </Card.Body>
                        </Card>
                      </Grid>
                    }
                    {values.isCriteriaActive &&
                      <Grid item xs={10} className="mt-3">
                        <Card>
                          <Card.Header as="h5">Contract Selection Criteria</Card.Header>
                          <Card.Body>
                            <ContractSelectionCriteriaFieldArray
                              values={values}
                              contractCriteria={contractCriteria}
                              handleChange={handleChange}
                              handleBlur={handleBlur}
                              touched={touched}
                              errors={errors}
                              setFieldValue={setFieldValue}
                              npiRoles={npiRoles}
                              dischargeStatusCodes={dischargeStatusCodes}
                            />
                          </Card.Body>
                        </Card>
                      </Grid>
                    }
                    {
                      values.isPpsSelectionActive && <>
                      <Grid item xs={10} className="mt-3">
                        <Paper elevation={3} 
                          sx={{ backgroundColor: '#f0f7ff', padding: 2 }}>
                          <Grid id="ipps-div" item xs={12}>
                            <Card>
                              <Card.Header className="d-flex justify-content-between align-items-center">
                                <Typography variant="h6"> IPPS configurations (Optional)</Typography>
                                <Tooltip title="Enable/Disable the section">
                                  <Switch
                                    name="IPPSSectionEnabled"
                                    color="primary"
                                    checked={values.IPPSSectionEnabled}
                                    onChange={(e) => {
                                      const checked = e.target.checked;
                                      if(values.SNFSectionEnabled || values.IRFSectionEnabled || values.IPFSectionEnabled) {
                                        setFieldValue("IPPSSectionEnabled", true);
                                      }
                                      else {
                                        setFieldValue("IPPSSectionEnabled", checked);
                                      }
                                    }}
                                    onBlur={handleBlur}
                                  />
                                </Tooltip>
                              </Card.Header>
                              <Card.Body style={{ opacity: values.IPPSSectionEnabled ? 1 : 0.5 }}>
                                <ContractPpsSelectionCriteriaFieldArray
                                  values={values}
                                  drgs={drgs}
                                  touched={touched}
                                  errors={errors}
                                  setFieldValue={setFieldValue}
                                  disabled={!values.IPPSSectionEnabled}
                                />
                              </Card.Body>
                            </Card>
                          </Grid>
                          <Grid id="snf-div" item xs={12} className="mt-3">
                            <Card>
                              <Card.Header className="d-flex justify-content-between align-items-center">
                                <Typography variant="h6"> Skilled Nursing Facility (SNF) PPS configurations (Optional)</Typography>
                                <Tooltip title="Enable/Disable the section">
                                  <Switch
                                    name="SNFSectionEnabled"
                                    color="primary"
                                    checked={values.SNFSectionEnabled}
                                    onChange={(e) => {
                                      const checked = e.target.checked;
                                      setFieldValue("SNFSectionEnabled", checked);
                                      if (checked) {
                                        setFieldValue("IPPSSectionEnabled", true);
                                      }
                                    }}
                                    onBlur={handleBlur}
                                  />
                                </Tooltip>
                              </Card.Header>
                              <Card.Body style={{ opacity: values.SNFSectionEnabled ? 1 : 0.5 }}>
                                <ContractSNFSelectionCriteriaFieldArray
                                  values={values}
                                  touched={touched}
                                  errors={errors}
                                  setFieldValue={setFieldValue}
                                  disabled={!values.SNFSectionEnabled}
                                />
                              </Card.Body>
                            </Card>
                          </Grid>
                          <Grid id="irf-div" item xs={12} className="mt-3">
                            <Card>
                              <Card.Header className="d-flex justify-content-between align-items-center">
                                <Typography variant="h6"> Inpatient Rehabilitation Facility (IRF) PPS configurations (Optional)</Typography>
                                <Tooltip title="Enable/Disable the section">
                                  <Switch
                                    name="IRFSectionEnabled"
                                    color="primary"
                                    checked={values.IRFSectionEnabled}
                                    onChange={(e) => {
                                      const checked = e.target.checked;
                                      setFieldValue("IRFSectionEnabled", checked);
                                      if (checked) {
                                        setFieldValue("IPPSSectionEnabled", true);
                                      }
                                    }}
                                    onBlur={handleBlur}
                                  />
                                </Tooltip>
                              </Card.Header>
                              <Card.Body style={{ opacity: values.IRFSectionEnabled ? 1 : 0.5 }}>
                                <ContractIRFSelectionCriteriaFieldArray
                                  values={values}
                                  touched={touched}
                                  errors={errors}
                                  setFieldValue={setFieldValue}
                                  disabled={!values.IRFSectionEnabled}
                                />
                              </Card.Body>
                            </Card>
                          </Grid>
                          <Grid id="ipf-div" item xs={12} className="mt-3">
                            <Card>
                              <Card.Header className="d-flex justify-content-between align-items-center">
                                <Typography variant="h6"> Inpatient Psychiatric Facility (IPF) PPS configurations (Optional)</Typography>
                                <Tooltip title="Enable/Disable the section">
                                  <Switch
                                    name="IPFSectionEnabled"
                                    color="primary"
                                    checked={values.IPFSectionEnabled}
                                    onChange={(e) => {
                                      const checked = e.target.checked;
                                      setFieldValue("IPFSectionEnabled", checked);
                                      if (checked) {
                                        setFieldValue("IPPSSectionEnabled", true);
                                      }
                                    }}
                                    onBlur={handleBlur}
                                  />
                                </Tooltip>
                              </Card.Header>
                              <Card.Body style={{ opacity: values.IPFSectionEnabled ? 1 : 0.5 }}>
                                <ContractIPFSelectionCriteriaFieldArray
                                  values={values}
                                  touched={touched}
                                  errors={errors}
                                  setFieldValue={setFieldValue}
                                  disabled={!values.IPFSectionEnabled}
                                />
                              </Card.Body>
                            </Card>
                          </Grid>
                          <Grid id="ltch-div" item xs={12} className="mt-3">
                            <Card>
                              <Card.Header className="d-flex justify-content-between align-items-center">
                                <Typography variant="h6"> Long Term Care Hospital (LTCH) PPS configurations (Optional)</Typography>
                                <Tooltip title="Enable/Disable the section">
                                  <Switch
                                    name="LTCHSectionEnabled"
                                    color="primary"
                                    checked={values.LTCHSectionEnabled}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                  />
                                </Tooltip>
                              </Card.Header>
                              <Card.Body style={{ opacity: values.LTCHSectionEnabled ? 1 : 0.5 }}>
                                <ContractLTCHSelectionCriteriaFieldArray
                                  values={values}
                                  touched={touched}
                                  errors={errors}
                                  setFieldValue={setFieldValue}
                                  disabled={!values.LTCHSectionEnabled}
                                />
                              </Card.Body>
                            </Card>
                          </Grid>
                        </Paper>
                      </Grid>
                      <Grid id="opps-div" item xs={10} className="mt-3">
                        <Card>
                          <Card.Header className="d-flex justify-content-between align-items-center">
                                <Typography variant="h6"> OPPS configurations (Optional)</Typography>
                                <Tooltip title="Enable/Disable the section">
                                  <Switch
                                    name="OPPSSectionEnabled"
                                    color="primary"
                                    checked={values.OPPSSectionEnabled}
                                    onChange={(e) => {
                                      const checked = e.target.checked;
                                      if (checked) {
                                        setFieldValue("OPPSSectionEnabled", true);
                                        setFieldValue("EAPGSectionEnabled", false);
                                      }
                                      else {
                                        setFieldValue("OPPSSectionEnabled", checked);
                                      }
                                    }}
                                    onBlur={handleBlur}
                                  />
                                </Tooltip>
                              </Card.Header>
                          <Card.Body  style={{ opacity: (!values.isEAPGSelectionActive || values.OPPSSectionEnabled) ? 1 : 0.5 }}>
                            <ContractOPPSSelectionCriteriaFieldArray
                              values={values}
                              oppsList={oppsList}
                              touched={touched}
                              errors={errors}
                              setFieldValue={setFieldValue}
                              disabled={(values.isEAPGSelectionActive || !values.OPPSSectionEnabled)}
                              isEapgEnabled={values.isEAPGSelectionActive}
                            />
                          </Card.Body>
                        </Card>
                      </Grid>
                      </>
                    }
                    {
                      values.isEAPGSelectionActive && hasEapgAccess &&
                      <Grid id="eapg-div" item xs={10} className="mt-3">
                        <Card>
                          <Card.Header className="d-flex justify-content-between align-items-center">
                            <Typography variant="h6"> EAPG configurations (Optional)</Typography>
                            <Tooltip title="Enable/Disable the section">
                              <Switch
                                name="EAPGSectionEnabled"
                                color="primary"
                                checked={values.EAPGSectionEnabled}
                                onChange={handleChange}
                                onBlur={handleBlur}
                              />
                            </Tooltip>
                          </Card.Header>
                          <Card.Body style={{ opacity: values.EAPGSectionEnabled ? 1 : 0.5 }}>
                            <>
                              <ContractEAPGSelectionCriteriaFieldArray
                                values={values}
                                eapgList={eapgList}
                                touched={touched}
                                errors={errors}
                                setFieldValue={setFieldValue}
                                disabled={!values.EAPGSectionEnabled}
                              />
                              {eapgEffectiveDateWarning && (
                                <Alert severity="warning" sx={{ marginTop: 2 }}>
                                  The claim will be ignored if the effective date falls between the contract effective date and the EAPG effective date.
                                </Alert>
                              )}
                            </>
                          </Card.Body>
                        </Card>
                      </Grid>
                    }

                    {
                      values.isDenialCasCodeActive &&
                      <Grid item xs={10} className="mt-3">
                        <Card>
                          <Card.Header as="h5">Contract Denial Code Selection (Optional)</Card.Header>
                          <Card.Body>
                            <ContractDenialCodeSelection
                              values={values}
                              casCodes={casCodes}
                              setFieldValue={setFieldValue}
                            />
                          </Card.Body>
                        </Card>
                      </Grid>
                    }
                    {values.isAllowableCodeActive &&
                      <Grid item xs={10} className="mt-3">
                        <Card>
                          <Card.Header as="h5" className={`${Boolean(errors.contractOtherAllowableXref) && classes.redColor}`}>Other Allowable (Optional)
                          {Boolean(errors.contractOtherAllowableXref) && <span className={classes.errorText}> (Patient responsibility codes cannot be used for Other Allowables.)</span>}
                          </Card.Header>
                          <Card.Body>
                            <ContractAllowableCodeSelection
                              values={values}
                              casCodes={casCodes.filter(cc => cc.code !== '1' && cc.code !== '2' && cc.code !== '3')}
                              setFieldValue={setFieldValue}
                            />
                          </Card.Body>
                        </Card>
                      </Grid>
                    }
                    {
                      isEdit && (
                        <Grid item xs={10} className="mt-3">
                          <DocumentUpload contractId={contractId} handleUploadCallback={handleUploadCallback} module={MODULE_TYPE_CONTRACT} shouldDeleteDocument={true}/>
                        </Grid>
                      )
                    }
                    <Grid item xs={10} className="mt-3">
                      <ContactFieldArray
                        mode={mode}
                        handleBlur={handleBlur}
                        handleChange={handleChange}
                        touched={touched}
                        errors={errors}
                        vendorContacts={values.vendorContacts}
                        contactTemplate={contactTemplate}
                      />
                    </Grid>
                  </Grid >
                </div >
              </PortletBody >
            </Portlet >
            <NotesDialog
              open={notesOpen}
              onClose={() => setNotesOpen(false)}
              title={values?.name || 'Contract'}
              noteType={NoteType.Contract}
              notes={notes || []}
              totalCount={notesCount || 0}
              page={notesPage}
              rowsPerPage={NOTES_PAGE_SIZE}
              loading={notesListPending}
              saving={notesSavePending}
              exporting={notesExportPending}
              entityId={contractId}
              onRefresh={handleRefreshNotes}
              onPageChange={handleNotesPageChange}
              sortModel={notesSortModel}
              onSortModelChange={handleNotesSortModelChange}
              onSaveInline={handleSaveNotes}
              onExport={handleExportNotes}
              />
              <EntityAuditLogsDialog
                open={auditLogsOpen}
                onClose={() => setAuditLogsOpen(false)}
                title={values?.name || 'contract'}
                itemType="CONTRACT"
                entityId={contractId}
              />
          </form >
        )
        }
      </Formik >
    </Loadable >
    </>
  );
}